/* tslint:disable */
declare global {
  interface Window {
    dataLayer: IAnalyticsEvent[]
  }
}

interface IAnalyticsEvent {
  event: string
  category?: string
  label?: string
}

export const trackEvent = <TEvent extends IAnalyticsEvent>(event: TEvent) => {
  if (window.dataLayer) {
    // @TODO; Remove debugging when we can view tracking info
    console.log('tracking', JSON.stringify(event, null, 2))
    window.dataLayer.push(event)
  }
}



// WEBPACK FOOTER //
// ./src/analytics/Analytics.tsx